import React from 'react';
import { connect } from 'react-redux';
import { Toast, ToastContainer } from '@salesforce/design-system-react';
import { removeToast } from '../../actions';
const CustomToastContainer = (props) => {
  const createToast = (toast) => {
    return (
      <Toast
        duration={4500}
        {...toast}
        key={toast.id}
        onRequestClose={(e) => {
          props.removeToast(toast.id);
        }}
      />
    );
  };

  return (
    <ToastContainer>
      {props.toasts.length ? props.toasts.map(createToast) : null}
    </ToastContainer>
  );
};

const mapStateToProps = (state) => ({
  toasts: state.app.toasts,
});

const mapDispatchToProps = (dispatch) => ({
  removeToast: (toastId) => dispatch(removeToast(toastId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomToastContainer);
